<template>
	<div>
		<auth-container v-if="$route.name === 'SwcdList'" :page="page">
			<h2 class="mb-4">SWCDs</h2>

			<grid-view ref="swcdsTable" api-url="swcds" small use-filter :fields="table.fields"
					   :default-sort="table.sort" :default-reverse="table.reverse" :default-per-page="table.itemsPerPage"
					   collection-description="SWCDs" show-create
					   item-name="SWCD"
					   allow-export export-file-name="swcds" :export-ignore-fields="['geometry','dams']">
				<b-button v-if="isAuthorized(roleNames.superAdmin)" variant="primary" @click="page.showModal = true">Import</b-button>
			</grid-view>

			<b-modal v-model="page.showModal" title="Upload SWCDs" scrollable size="lg">
				<error-list :errors="page.saveErrors"></error-list>
				<success-alert ref="savedAlert" text="Changes saved." />

				<vue-dropzone ref="addFile" id="addFile" :options="dropzoneOptions" @vdropzone-success="fileUploaded" @vdropzone-error="uploadError"></vue-dropzone>

				<p class="mt-3">
					Upload a GeoJson file of SWCDs. Must include feature properties labeled as <code>SWCD__</code> and <code>SWCD_NAME</code> and be in the WGS84 coordinate system.
				</p>

				<div slot="modal-footer">
					<b-button type="button" variant="primary" @click="page.showModal = false" class="ml-1">Close</b-button>
				</div>
			</b-modal>
		</auth-container>
		<router-view></router-view>
	</div>
</template>

<script>
	import GridView from '@/components/helpers/GridView';
	import vue2Dropzone from 'vue2-dropzone';
	import 'vue2-dropzone/dist/vue2Dropzone.min.css';

	export default {
		name: 'SwcdList',
		components: {
			GridView, vueDropzone: vue2Dropzone
		},
		data() {
			return {
				page: {
					errors: [],
					loading: false,
					showLogin: false,
					saveErrors: [],
					showModal: false
				},
				dropzoneOptions: {
					url: '/api/swcds/upload/',
					headers: this.getTokenHeader().headers,
					acceptedFiles: '.geojson,.json'
				},
				table: {
					fields: [
						{ key: 'edit', label: '' },
						{ key: 'id', label: 'SWCD#', sortable: true },
						{ key: 'name', label: 'Name', sortable: true }
					],
					sort: 'id',
					reverse: false,
					itemsPerPage: 100
				}
			}
		},
		methods: {
			async fileUploaded(file, response) {
				this.log(file);
				this.log(response);
				this.page.saveErrors = [];
				await this.$refs.swcdsTable.get();
				this.$refs.savedAlert.startAlert();
			},
			uploadError(file, message, xhr) {
				this.log(file);
				this.log(xhr);
				this.page.saveErrors.push(message);
			}
		}
	}
</script>